module.exports = "button{\r\n    width:100px;\r\n    margin-right: 5px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/ContactUs/ContactUs.component.css
// module id = ./src/app/home/ContactUs/ContactUs.component.css
// module chunks = main